import { GetStaticProps } from "next";
import styled from "@emotion/styled";
import { colors, NextLink } from "goi_common";

// 발행된 콘텐츠 허브. 새 아티클 추가 시 이 배열에 카드 1개씩 추가(최신순).
const HUB_ITEMS = [
  {
    href: "/content/eunpyeong-seongmo-review-1505/",
    date: "2026.07.24",
    dateTime: "2026-07-24",
    title: "첫 부모님 장례, 끝까지 혼자가 아니었어요",
    desc: "서울은평성모장례식장 빈소부터 서울시립승화원 화장장·장지까지, 어린 두 상주 곁을 지킨 장례지도사의 동행 이야기 (후기 1505).",
  },
  {
    href: "/guide/mubinso-gajokjang/",
    date: "2026.07.21",
    dateTime: "2026-07-21",
    title: "무빈소 vs 가족장, 무엇이 다를까",
    desc: "빈소·조문을 빼면 비용과 절차가 어떻게 달라질까. '무빈소 가족장'의 정확한 뜻과 우리 가족에게 맞는 선택.",
  },
  {
    href: "/guide/hwajangjang-yeyak/",
    date: "2026.07.21",
    dateTime: "2026-07-21",
    title: "화장장 예약이 어려운 이유",
    desc: "3일장이 4일장으로 밀리는 이유, e하늘 예약과 관내·관외 요금까지 - 화장 예약 전 꼭 볼 것.",
  },
];

export const getStaticProps: GetStaticProps = async () => {
  const title = "콘텐츠 - 헤이상조";
  const description =
    "화장장 예약, 무빈소·가족장 선택, 장례 절차와 비용까지 - 갑작스러운 장례 준비에 꼭 필요한 정보를 헤이상조가 정리한 콘텐츠 모음.";

  return {
    props: {
      pageDescription: description,
      pageOgTitle: title,
      pageOgDescription: description,
      pageKeywords: "",
      pageOgImage: "",
    },
  };
};

const ContentIndexPage = () => {
  return (
    <Container>
      <Heading>콘텐츠</Heading>
      <Sub>장례 준비에 도움이 되는 이야기를 모았어요.</Sub>
      <CardList>
        {HUB_ITEMS.map((item) => (
          <Article key={item.href}>
            <CardLink href={item.href} style={{ flexDirection: "column", alignItems: "flex-start" }}>
              <CardDate dateTime={item.dateTime}>{item.date}</CardDate>
              <CardTitle>{item.title}</CardTitle>
              <CardDesc>{item.desc}</CardDesc>
              <CardArrow aria-hidden="true">자세히 보기 →</CardArrow>
            </CardLink>
          </Article>
        ))}
      </CardList>
    </Container>
  );
};

const Container = styled.div`
  padding: 24px 20px 32px;
  color: ${colors.white};
`;

const Heading = styled.h1`
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
`;

const Sub = styled.p`
  margin: 8px 0 0;
  font-size: 13.5px;
  color: ${colors.gray400};
`;

const CardList = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Article = styled.article`
  background: ${colors.gray800};
  border: 1px solid ${colors.gray700};
  border-radius: 14px;
  overflow: hidden;
`;

const CardLink = styled(NextLink)`
  width: 100%;
  padding: 18px 16px;
  color: inherit;
`;

const CardDate = styled.time`
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: ${colors.gray500};
`;

const CardTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.white};
  letter-spacing: -0.02em;
`;

const CardDesc = styled.p`
  margin: 6px 0 0;
  font-size: 13px;
  line-height: 1.55;
  color: ${colors.gray300};
`;

const CardArrow = styled.span`
  display: block;
  margin-top: 12px;
  font-size: 13px;
  font-weight: 700;
  color: ${colors.blue650};
`;

export default ContentIndexPage;
